import { API_AUTH } from "./common";

const QuanLyChoVayApi = {
  thanhToan: ({ choVayId, soTien }) =>
    API_AUTH.post(
      `quan-ly-thu-chi/thanh-toan?choVayId=${choVayId}&soTien=${soTien}`,
      {}
    ),
  thanhToanAll: ({
    ChoVayId,
    TenKhachHang,
    NgayTra,
    SoTienDong,
    PhiKho,
    PhiKhac,
    Code,
    GhiChu,
    DoiKy,
    DongThemQuaHan,
    SoTienPhaiDong,
    PhiPhatTraLai,
    PhiDongLaiCham,
  }) =>
    API_AUTH.post(`quan-ly-thu-chi/thanh-toan-all`, {
      ChoVayId,
      TenKhachHang,
      NgayTra,
      SoTienDong,
      PhiKho,
      PhiKhac,
      Code,
      GhiChu,
      DoiKy,
      DongThemQuaHan,
      SoTienPhaiDong,
      PhiPhatTraLai,
      PhiDongLaiCham,
    }),
  xoaThanhToan: ({ thuChiId }) =>
    API_AUTH.delete(`quan-ly-thu-chi/xoa-thanh-toan?id=${thuChiId}`, {}),
  detail: (choVayId) => API_AUTH.get("quan-ly-thu-chi/chi-tiet?id=" + choVayId, {}),
  chiTietThuChi: (id) => API_AUTH.get(`thu-chi/chi-tiet?id=${id}`, {}),
};

export default QuanLyChoVayApi;
